import axios from 'axios';
import { ImageFileTypes } from 'src/infrastructure/ImageFileTypes';
import { ITechReferenceSheet, ITechReferenceSheetType } from 'src/infrastructure/interfaces';

export default class AgronomyReferenceSheetServiceService {

  static toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet: ITechReferenceSheet) {
    return new Promise((resolve, reject) => {
    axios
        .put(`/agronomy_reference/${agronomyReferenceSheet.id}`, agronomyReferenceSheet)
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  
  static createAgronomyReferenceSheet(sheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData) {
    formData.set("title", sheetName);
    formData.set("sheet_category", agronomyReferenceSheetType);
    return new Promise((resolve, reject) => {
      axios
        .post('/agronomy_reference',
            formData,
            { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  
  static editAgronomyReferenceSheet(sheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData, sheetToEdit: ITechReferenceSheet) {
    sheetToEdit.title = sheetName;
    sheetToEdit.sheet_category = agronomyReferenceSheetType;
    return new Promise((resolve, reject) => {
      sheetToEdit.title = sheetName;
      axios
        .put(`/agronomy_reference/${sheetToEdit.id}`, sheetToEdit)
        .then((res) => {
            if (formData.has(ImageFileTypes.AGRONOMY_REFERENCE_SHEET)) {
              formData.set("title", sheetName);
              formData.set("sheet_category", agronomyReferenceSheetType);
              formData.set("id", sheetToEdit.id.toString());
              axios
                .post(`/agronomy_reference_image_swap`, formData)
                .then((res) => {
                  resolve(res.data);
                })
            } else {
              resolve(res.data);
            }
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/AgronomyReferenceSheetService.ts